// extracted by mini-css-extract-plugin
export var image = "index-v2-module--image--1c661";
export var imageWrapper = "index-v2-module--imageWrapper--3de60";
export var info = "index-v2-module--info--e335b";
export var infoWrapper = "index-v2-module--infoWrapper--fab0c";
export var promotionLink = "index-v2-module--promotionLink--6daac";
export var promotionsPanelWrapper = "index-v2-module--promotionsPanelWrapper--a8b3c";
export var secondaryInfo = "index-v2-module--secondaryInfo--a5ea0";
export var tag = "index-v2-module--tag--1ba6f";
export var text = "index-v2-module--text--2c314";